import { Component, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { FnLoaderService, FnLoaderType, FnModalService, FnTableConfig, FnTableMetaData, FnUtilService } from 'foundation';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as am5plugins_exporting from '@amcharts/amcharts5/plugins/exporting';
import am5themes_Dark from '@amcharts/amcharts5/themes/Dark';
import { FnAppSessionService, FnToasterService } from 'foundation';
import { DatePipe } from '@angular/common';
import { EOProduct, EOStatusType } from '../../../modal/entity.modal';
import { PosHttpService } from '../../../services/pos.http.service';
import { InfoGraphModelComponent } from './info-graph-model/info-graph-model.component';

@Component({
  selector: 'app-day-analysis',
  templateUrl: './day-analysis.component.html',
  styleUrls: ['./day-analysis.component.scss']
})
export class DayAnalysisComponent implements AfterViewInit, OnDestroy {
  isLoadingDone = true;
  showData = true;
  Total = true;
  Critical = false;
  Manually = false;
  customDate = true;
  private root!: am5.Root;
  private chart!: am5xy.XYChart;
  private xAxis!: am5xy.CategoryAxis<am5xy.AxisRendererX>;
  private yAxis!: am5xy.ValueAxis<am5xy.AxisRendererY>;
  maxDateRange = new Date();
  startDate: any;
  endDate: any;
  productArray: EOProduct[] = [];
  idenNoArray: EOStatusType[] = [];
  selectProduct: any;
  selectIdenNo: any;
  selectedDay: any;
  private chartTitle!: am5.Label;
  private detailRoot: am5.Root | null = null;
  private detailChart: am5xy.XYChart | null = null;
  private detailContainer: HTMLElement | null = null;
  showDetail: boolean = false;
  ngOnInit() {
    this.loadEOProduct();
  }

  chartData: { busiDate: string; alertOccurance: number; detail: { name: string; count: number }[]; dailycount?: { name: string; count: number }[] }[] = [];
  
 //chartData = [
 // { busiDate: '24 Feb', alertOccurance: 352, detail: [{name: 'sdd', count: 65}], dailycount: [{name: 'sdd', count: 65}] },
 // { busiDate: '25 Feb', alertOccurance: 2232, detail: [{name: 'sdd', count: 65}] },
 // { busiDate: '26 Feb', alertOccurance: 68, detail: [{name: 'sdd', count: 65}] },
 //];

  dayArray=[
    {'key':'2Weeks','value':'Last 2 Weeks'},
    {'key':'4Weeks','value':'Last 4 Weeks'},
    {'key':'6Weeks','value':'Last 6 Weeks'},
    {'key':'Sunday','value':'Last 10 Sunday'},
    {'key':'Monday','value':'Last 10 Monday'},
    {'key':'Tuesday','value':'Last 10 Tuesday'},
    {'key':'Wednesday','value':'Last 10 Wednesday'},
    {'key':'Thursday','value':'Last 10 Thursday'},
    {'key':'Friday','value':'Last 10 Friday'},
    {'key':'Saturday','value':'Last 10 Saturday'}
    ];

  constructor(private elementRef: ElementRef, private fnModalSvcs: FnModalService, private dialogSvcs: FnModalService, public datepipe: DatePipe, private fnutilservice: FnUtilService, private apSessionSvcs: FnAppSessionService, private posHttpSvcs: PosHttpService, private toaster: FnToasterService, 
      private loader: FnLoaderService) { 
    this.loader.hide();
    this.loader.setloaderType(FnLoaderType.MANUAL);
  }

  ngAfterViewInit(): void {
    this.createChart();
  }

  dateRangeObject = {
    startDate: new Date(),
    endDate: new Date()
  };

  changeDate(event: any) {
    this.startDate = this.datepipe.transform(event.startDate, 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(event.endDate, 'yyyy-MM-dd');
  }

  productValue(): string | undefined {
    return this.productArray.find(item => item.primaryKey === this.selectProduct)?.name;
  }

  idenNoValue(): string | undefined {
    return this.idenNoArray.find(item => item.primaryKey === this.selectIdenNo)?.idenNo;
  }

  loadEOProduct() {
    this.posHttpSvcs.authGet('v1/ui/loadProductName', 'loadProductName').subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('product name not loaded');
        return;
      }
      this.productArray = resp.data;
    })
  }

  getIdenNoData(selectProduct: string) {
    this.selectProduct = selectProduct;

    this.posHttpSvcs.authPost('v1/ui/loadIdenNo', 'loadIdenNo', selectProduct).subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Iden no not Selected');
        return;
      }
      this.idenNoArray = resp.data;
    })

  }

  getProductStats() {
    if (this.customDate && this.fnutilservice.isEmptyObject(this.selectedDay)) {
      this.toaster.error('Please select custom date');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectProduct)) {
      this.toaster.error('Please select Product');
      return;
    }
    const requestMap: any = {
      pk: this.selectProduct,
      customDate: this.customDate,
      ...(this.customDate
        ? { selectedDay: this.selectedDay }
        : { startDate: this.startDate, endDate: this.endDate })
    };
    this.posHttpSvcs.authPost('v1/ui/loadProductStats', 'loadProductStats', requestMap).subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Something went wrong');
        return;
      }
      this.chartData = resp.data && resp.data.length > 0 ? resp.data : [];
      if (this.chartTitle) {
        this.chartTitle.set('text', `Product Wise Count (${this.productValue()})`);
      }

      if (this.chart) {
        this.xAxis.data.setAll(this.chartData);
        this.chart.series.each(series => series.data.setAll(this.chartData));
      }
    })
  }

  getHistData(selectIdenNo: number) {
    if (this.customDate && this.fnutilservice.isEmptyObject(this.selectedDay)) {
      this.toaster.error('Please select custom date');
      return;
    }
    const requestMap: any = {
      pk: selectIdenNo,
      customDate: this.customDate,
      ...(this.customDate
        ? { selectedDay: this.selectedDay }
        : { startDate: this.startDate, endDate: this.endDate })
    };
    this.posHttpSvcs.authPost('v1/ui/loadIdenNoStats', 'loadIdenNoStats', requestMap).subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Something went wrong');
        return;
      }
      this.chartData = resp.data && resp.data.length > 0 ? resp.data : [];
      if (this.chartTitle) {
        this.chartTitle.set('text', `Alert Wise Count (${this.idenNoValue()})`);
      }
      if (this.chart) {
        this.xAxis.data.setAll(this.chartData);
        this.chart.series.each(series => series.data.setAll(this.chartData));
      }
    })
  }

  createChart(): void {
    const chartDiv = this.elementRef.nativeElement.querySelector('#chartdiv');
    if (!chartDiv) {
      console.error('Chart container not found');
      return;
    }
    this.root = am5.Root.new(chartDiv);
    if (this.root._logo) {
      this.root._logo.dispose();
    }

    this.root.container.set("background", am5.Rectangle.new(this.root, {
      fill: am5.color(this.apSessionSvcs.isDarkTheme() ? 0x121418 : 0xf3f1f1),
      fillOpacity: 1
    }));

    this.root.setThemes(this.apSessionSvcs.isDarkTheme() ?
      [am5themes_Animated.new(this.root), am5themes_Dark.new(this.root)] :
      [am5themes_Animated.new(this.root)]
    );

    this.chart = this.root.container.children.push(
      am5xy.XYChart.new(this.root, {
        panX: true,
        panY: true,
        wheelX: 'panX',
        wheelY: 'zoomX',
        layout: this.root.verticalLayout
      })
    );
    this.chartTitle = am5.Label.new(this.root, {
      text: '',
      fontSize: 18,
      textAlign: 'center',
      x: am5.percent(50),
      centerX: am5.percent(50)
    });
    this.chart.children.unshift(this.chartTitle);
    this.chart.children.push(
      am5.Label.new(this.root, {
        x: am5.percent(50),
        centerX: am5.percent(50),
        y: 30
      })
    );

    const xRenderer = am5xy.AxisRendererX.new(this.root, {
      minGridDistance: 30, strokeOpacity: 1,
      strokeWidth: 1,
      stroke: am5.color(this.apSessionSvcs.isDarkTheme() ? 0xFFFFFF : 0x000000)
    });
    xRenderer.grid.template.set("visible", false);

    this.xAxis = this.chart.xAxes.push(
      am5xy.CategoryAxis.new(this.root, {
        renderer: xRenderer,
        categoryField: 'busiDate',
        tooltip: am5.Tooltip.new(this.root, {})
      })
    );
    this.xAxis.data.setAll(this.chartData);

    const yRenderer = am5xy.AxisRendererY.new(this.root, {
      strokeOpacity: 1,
      strokeWidth: 1,
      stroke: am5.color(this.apSessionSvcs.isDarkTheme() ? 0xFFFFFF : 0x000000)
    });
    yRenderer.grid.template.set("visible", false);

    this.yAxis = this.chart.yAxes.push(
      am5xy.ValueAxis.new(this.root, {
        renderer: yRenderer,
        numberFormat: "#",
        tooltip: am5.Tooltip.new(this.root, {})
      })
    );

    this.createSeries();

    const cursor = this.chart.set('cursor', am5xy.XYCursor.new(this.root, {}));
    cursor.lineX.set('visible', false);
    cursor.lineY.set('visible', false);

    const legend = this.chart.children.push(
      am5.Legend.new(this.root, {
        x: am5.percent(50),
        centerX: am5.percent(50),
        layout: am5.GridLayout.new(this.root, { maxColumns: 15, fixedWidthGrid: true })
      })
    );
    legend.data.setAll(this.chart.series.values);

    am5plugins_exporting.Exporting.new(this.root, {
      menu: am5plugins_exporting.ExportingMenu.new(this.root, {}),
      dataSource: this.chartData
    });

    this.isLoadingDone = true;
  }

  createSeries(): void {
    const series = this.chart.series.push(
      am5xy.ColumnSeries.new(this.root, {
        name: 'Alert Occurrence',
        xAxis: this.xAxis,
        yAxis: this.yAxis,
        valueYField: 'alertOccurance',
        categoryXField: 'busiDate',
        tooltip: am5.Tooltip.new(this.root, { labelText: '{busiDate}: {valueY.formatNumber("#")}' })
      })
    );

    series.columns.template.setAll({
      maxWidth: 80,
      width: am5.percent(80),
      fill: am5.color(0xFF6464),
      strokeOpacity: 0
    });

    series.columns.template.events.on("click", (ev) => {
      const dataItem = ev.target.dataItem;
      if (!dataItem) {
        console.error('No data item found for the clicked column');
        return;
      }
      const data = dataItem.dataContext as {
        busiDate: string;
        detail: { name: string; count: number }[]
      };
      this.showDetailChart(data.busiDate, data);
    });

    series.data.setAll(this.chartData);

    series.bullets.push(() =>
      am5.Bullet.new(this.root, {
        locationY: 1,
        sprite: am5.Label.new(this.root, {
          text: '{valueY}',
          fontSize: 12,
          fill: am5.color(this.apSessionSvcs.isDarkTheme() ? 0xFFFFFF : 0x000000),
          centerX: am5.percent(50),
          centerY: am5.percent(40),
          dy: -10,
          populateText: true,
        }),
      })
    );
  }

  showDetailChart(
    busiDate: string,
    data: { detail: { name: string; count: number }[]; dailycount?: { name: string; count: number }[] }
  ): void {
    if (this.detailRoot) {
      this.detailRoot.dispose();
      this.detailRoot = null;
    }
    if (this.detailContainer) {
      this.detailContainer.remove();
      this.detailContainer = null;
    }

    const detailData = data.detail;
    const dailyCountData = data.dailycount;
    const hasDailyCount = !!dailyCountData;

    this.detailContainer = document.createElement('div');
    this.detailContainer.id = 'detail-container';
    this.detailContainer.style.position = 'fixed';
    this.detailContainer.style.top = '0';
    this.detailContainer.style.left = '0';
    this.detailContainer.style.width = '100%';
    this.detailContainer.style.height = '100%';
    this.detailContainer.style.backgroundColor = 'rgba(0,0,0,0.5)';
    this.detailContainer.style.zIndex = '1000';
    this.detailContainer.style.display = 'flex';
    this.detailContainer.style.justifyContent = 'center';
    this.detailContainer.style.alignItems = 'center';
    this.detailContainer.style.zIndex = '3';
    this.detailContainer.innerHTML = `
      <style>
        .tab-container {
          display: flex;
          border-bottom: 0px solid #ccc;
          margin-bottom: 3px;
        }
        .tab {
          padding: 8px 16px;
          cursor: pointer;
          background:rgb(178, 219, 247);
          border: 1px solid #ccc;
          border-bottom: none;
          margin-right: 2px;
          color: black;
          border-radius: 4px 4px 0 0;
          transition: background 0.2s;
        }
        .tab.active {
          background:rgb(198, 224, 169);
          font-weight: bold;
          border-bottom: 1px solid #ffffff;
        }
        .tab:hover:not(.active) {
          background: #e0e0e0;
        }
          .info-icon {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 25px;
        color: red;
        cursor: pointer;
      }
      </style>
      <div id="detail-content" style="background: white; padding: 10px; width: 80%; max-width: 2000px; max-height: 80%; overflow: auto; border: 2px solid #333; border-radius: 5px; position: relative;">
        <i id="detail-info-icon" class="fn-global-info-o info-icon"></i>
      <div id="tabs" class="tab-container">
          <div id="detail-tab" class="tab active">Detail</div>
          ${hasDailyCount ? '<div id="dailycount-tab" class="tab">Unique Count</div>' : ''}
        </div>
        <div id="detail-chart" style="width: 100%; height: 400px;"></div>
      </div>
    `;

    document.body.appendChild(this.detailContainer);

    this.detailContainer.addEventListener('click', (event) => {
      const detailContent = this.detailContainer?.querySelector('#detail-content');
      if (detailContent && !detailContent.contains(event.target as Node)) {
        this.hideDetailChart();
      }
    });

    const infoIcon = this.detailContainer.querySelector('#detail-info-icon');
  if (infoIcon) {
    infoIcon.addEventListener('click', () => {
      this.infoDetails();
    });
  } else {
    console.error('Info icon not found in detail container');
  }

    const detailChartDiv = this.detailContainer.querySelector('#detail-chart') as HTMLElement;
    if (!detailChartDiv) {
      console.error('Detail chart div not found in container');
      return;
    }

    this.detailRoot = am5.Root.new(detailChartDiv);
    if (this.detailRoot._logo) {
      this.detailRoot._logo.dispose();
    }

    this.detailRoot.container.set("background", am5.Rectangle.new(this.detailRoot, {
      fill: am5.color(this.apSessionSvcs.isDarkTheme() ? 0x444444 : 0xf3f1f1),
      fillOpacity: 1
    }));


    this.detailRoot.setThemes(this.apSessionSvcs.isDarkTheme() ?
      [am5themes_Animated.new(this.detailRoot), am5themes_Dark.new(this.detailRoot)] :
      [am5themes_Animated.new(this.detailRoot)]
    );

    this.detailChart = this.detailRoot.container.children.push(
      am5xy.XYChart.new(this.detailRoot, {
        panX: true,
        panY: true,
        wheelX: 'panX',
        wheelY: 'zoomX',
        layout: this.detailRoot.verticalLayout
      })
    );

    const title = am5.Label.new(this.detailRoot, {
      text: `Detail for ${busiDate}`,
      fontSize: 18,
      textAlign: 'center',
      fill: am5.color(this.apSessionSvcs.isDarkTheme() ? 0xCCCCCC : 0x000000),
      x: am5.percent(50),
      centerX: am5.percent(50)
    });
    this.detailChart.children.unshift(title);

    const xRenderer = am5xy.AxisRendererX.new(this.detailRoot, {
      minGridDistance: 30, strokeOpacity: 1,
      strokeWidth: 1,
      stroke: am5.color(0x000000)
    });
    xRenderer.grid.template.set("visible", false);
    xRenderer.labels.template.set("visible", false);

    const xAxis = this.detailChart.xAxes.push(
      am5xy.CategoryAxis.new(this.detailRoot, {
        renderer: xRenderer,
        categoryField: 'name',
        tooltip: am5.Tooltip.new(this.detailRoot, {})
      })
    );

    const yRenderer = am5xy.AxisRendererY.new(this.detailRoot, {
      strokeOpacity: 1,
      strokeWidth: 1,
      stroke: am5.color(0x000000)
    });
    yRenderer.grid.template.set("visible", false);

    const yAxis = this.detailChart.yAxes.push(
      am5xy.ValueAxis.new(this.detailRoot, {
        renderer: yRenderer,
        numberFormat: "#",
        tooltip: am5.Tooltip.new(this.detailRoot, {})
      })
    );

    const series = this.detailChart.series.push(
      am5xy.ColumnSeries.new(this.detailRoot, {
        name: 'Count',
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: 'count',
        categoryXField: 'name',
        tooltip: am5.Tooltip.new(this.detailRoot, { labelText: '{name}: {valueY.formatNumber("#")}' })
      })
    );

    series.columns.template.setAll({
      maxWidth: 80,
      width: am5.percent(70),
      fill: am5.color(0xF0AC45),
      strokeOpacity: 0
    });

    const cursor = this.detailChart.set('cursor', am5xy.XYCursor.new(this.detailRoot, {}));
    cursor.lineX.set('visible', false);
    cursor.lineY.set('visible', false);

    series.bullets.push(() =>
      am5.Bullet.new(this.detailRoot!, {
        locationY: 1,
        sprite: am5.Label.new(this.detailRoot!, {
          text: '{valueY}',
          fontSize: 12,
          fill: am5.color(this.apSessionSvcs.isDarkTheme() ? 0xFFFFFF : 0x000000),
          centerX: am5.percent(50),
          centerY: am5.percent(40),
          dy: -10,
          populateText: true,
        })
      })
    );

    xAxis.data.setAll(detailData);
    series.data.setAll(detailData);

    const updateChartData = (dataArray: { name: string; count: number }[]) => {
      xAxis.data.setAll(dataArray);
      series.data.setAll(dataArray);
    };

    const updateChartTitle = (tab: 'detail' | 'dailycount') => {
      const titleText = tab === 'detail' ? `Detail for ${busiDate}` : `Unique Count for ${busiDate}`;
      title.set('text', titleText);
    };

    const setActiveTab = (tab: 'detail' | 'dailycount') => {
      const tabs = this.detailContainer!.querySelectorAll('.tab');
      tabs.forEach(t => t.classList.remove('active'));
      const selectedTab = this.detailContainer!.querySelector(`#${tab}-tab`);
      if (selectedTab) {
        selectedTab.classList.add('active');
      }
      const dataArray = tab === 'detail' ? detailData : dailyCountData;
      if (dataArray) {
        updateChartData(dataArray);
        updateChartTitle(tab);
      }
    };

    const detailTab = this.detailContainer.querySelector('#detail-tab');
    if (detailTab) {
      detailTab.addEventListener('click', () => setActiveTab('detail'));
    }

    if (hasDailyCount) {
      const dailycountTab = this.detailContainer.querySelector('#dailycount-tab');
      if (dailycountTab) {
        dailycountTab.addEventListener('click', () => setActiveTab('dailycount'));
      }
    }
  }

  hideDetailChart(): void {
    if (this.detailRoot) {
      this.detailRoot.dispose();
      this.detailRoot = null;
    }
    if (this.detailContainer) {
      this.detailContainer.remove();
      this.detailContainer = null;
    }
  }

  ngOnDestroy(): void {
    if (this.root) {
      this.root.dispose();
    }
    if (this.detailRoot) {
      this.detailRoot.dispose();
    }
    if (this.detailContainer) {
      this.detailContainer.remove();
    }
  }

  infoDetails() {
    const DashboardCommentModal = this.fnModalSvcs.openCustomModal(InfoGraphModelComponent, {
      hasBackdrop: true,
      width: '500px',
    });
  }

}
